import { Footer } from '../Components/Footer/FooterComponent';
import { LogoHeader } from '../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../Components/Inicio/NavDesktop';
import { NavMobile } from '../Components/Inicio//NavMobile';
import { Navigate } from 'react-router-dom';
import ActaViewer from '../Components/Descargas/ActaViewer';
import { normalizeAgeType } from '../utils/ageType';

export const View = (props) => {
    if (normalizeAgeType(props.User?.ageType) === 4) {
        return <Navigate to="/perfil" replace />;
    }

    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <ActaViewer I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>
    )
}
